module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_600.45f5e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/fullscreen-image_lets-get_600.png
// module id = ZL2t
// module chunks = 0